import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { PSEO_GROUPS } from "@/content/pseo";

/** Internal links into every programmatic guide, grouped by buyer need. */
export default function GuideHub({ title = "Find the answer for your kitchen.", limit = 6, dark = false }) {
  return (
    <section className={dark ? "bg-brand-obsidian text-brand-bone py-24" : "bg-brand-parchment py-24"} data-testid="guide-hub">
      <div className="max-w-6xl mx-auto px-6">
        <p className={`font-body text-[15px] font-semibold ${dark ? "text-brand-bone/70" : "text-brand-gold"}`}>Guides</p>
        <h2 className={`mt-2 font-display text-[clamp(2rem,5vw,3.25rem)] leading-[1.04] tracking-display ${dark ? "text-white" : "text-brand-ink"}`}>{title}</h2>
        <div className="mt-12 grid md:grid-cols-3 gap-4">
          {PSEO_GROUPS.map((g) => (
            <div key={g.key} className={`rounded-3xl p-7 ${dark ? "bg-white/5" : "bg-white"}`}>
              <h3 className={`font-display text-[22px] tracking-[-0.02em] ${dark ? "text-white" : "text-brand-ink"}`}>{g.title}</h3>
              <ul className="mt-4 space-y-2">
                {g.pages.slice(0, limit).map((p) => (
                  <li key={p.slug}>
                    <Link to={`/${p.slug}`} className={`group inline-flex items-center gap-1 font-body text-[15px] ${dark ? "text-brand-bone/80 hover:text-white" : "text-ink-muted hover:text-brand-ink"}`}>
                      {p.title} <ChevronRight className="w-3.5 h-3.5 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <Link to="/guides" className={`mt-8 inline-flex items-center gap-1 font-body text-[15px] ${dark ? "text-white" : "text-brand-gold"} hover:underline`}>
          All guides <ChevronRight className="w-4 h-4" />
        </Link>
      </div>
    </section>
  );
}
